import { render, staticRenderFns } from "./ManageInvestorsAccountDetails.vue?vue&type=template&id=4c243fc6"
import script from "./ManageInvestorsAccountDetails.vue?vue&type=script&lang=js"
export * from "./ManageInvestorsAccountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports